import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  EditOrderItemRootScreenParamList,
  EditStockOrderRootScreenParamList,
} from "../../../../types";
import { useStockOrderContextProvider } from "../../utils/active-stock-order";
import React from "react";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { OrderItemForm } from "../../components/OrderItemForm";
import { AddOrEditOrderItemScreen } from "../AddOrEditOrderItemScreen";
import { StockOrderItem } from "@towersystems/roam-common/lib/generated-types";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import { SelectedProductContext } from "../../../invoice-arrival/utils/selected-product/context";
import { useSelectedProduct } from "../../../invoice-arrival/utils/selected-product/hooks";
import { AddOrderItemScreenActionsContext } from "../AddOrEditOrderItemScreen/context";
import {
  EditProductRootScreen,
  ProductSelectSupplierScreen,
} from "../../../products/screens";
import { useFormContext } from "react-hook-form";
import { OrderItemFormValues } from "../../components/OrderItemForm/types";
import { ProductFormActionsContext } from "../../../products/components/ProductForm/context";
import { useSetupAllStartupEntities } from "../../../../utilities/setup";
import { stockOrderItemToFormValues } from "../../utils";

export type EditOrderItemModalRootScreenProps = StackScreenProps<
  EditStockOrderRootScreenParamList,
  "EditOrderItemModalRootScreen"
>;

const Drawer = () => {
  const { fetchAndSyncEntity } = useSetupAllStartupEntities();
  const { setValue } = useFormContext<OrderItemFormValues>();
  const Drawer = createStackHeaderNavigator<EditOrderItemRootScreenParamList>();

  return (
    <ProductFormActionsContext.Provider
      value={{
        onAfterAddProduct: async (createdProduct) => {
          await fetchAndSyncEntity("products");
          setValue("supplierId", createdProduct.supplierId ?? undefined);
          setValue(
            "supplierCode",
            createdProduct.supplierStockCode ?? undefined
          );
        },
      }}
    >
      <Drawer.Navigator
        screenOptions={{
          animationEnabled: true,
          headerLeft: () => <ModalCloseButton type="Back" />,
          title: "",
        }}
      >
        <Drawer.Screen
          name="AddOrEditOrderItemScreen"
          component={AddOrEditOrderItemScreen}
        />
        <Drawer.Group
          screenOptions={{
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            headerLeft: () => <ModalCloseButton type="Cancel" />,
          }}
        >
          <Drawer.Screen
            name="ProductSelectSupplierScreen"
            component={ProductSelectSupplierScreen}
          />
        </Drawer.Group>
        <Drawer.Group
          screenOptions={{
            headerShown: false,
            presentation: "modal",
          }}
        >
          <Drawer.Screen
            name="EditProductRootScreen"
            component={EditProductRootScreen}
          />
        </Drawer.Group>
      </Drawer.Navigator>
    </ProductFormActionsContext.Provider>
  );
};

export const EditOrderItemModalRootScreen = ({
  navigation,
  route,
}: EditOrderItemModalRootScreenProps) => {
  const [lineItem, setLineItem] = React.useState<StockOrderItem | undefined>(
    undefined
  );
  const { stockOrder } = useStockOrderContextProvider();
  const lineItemId = route.params.lineItemId;
  const database = useDatabase();
  const productContext = useSelectedProduct();

  const onAfterSubmitSuccess = React.useCallback(async () => {
    navigation.pop();
  }, []);

  React.useEffect(() => {
    (async () => {
      const i = stockOrder.items.find((item) => item.id === lineItemId);
      if (i) {
        setLineItem(i);
      }
    })();
  }, [lineItemId]);

  if (!lineItem) {
    return null;
  }

  return (
    <SelectedProductContext.Provider value={productContext}>
      <AddOrderItemScreenActionsContext.Provider
        value={{
          afterSubmitSuccess: onAfterSubmitSuccess,
        }}
      >
        <OrderItemForm.Provider
          defaultFormValues={stockOrderItemToFormValues(lineItem)}
        >
          <Drawer />
        </OrderItemForm.Provider>
      </AddOrderItemScreenActionsContext.Provider>
    </SelectedProductContext.Provider>
  );
};
